import React from "react";
import { Button } from "react-bootstrap";
import btnStyles from "../../styles/Button.module.css";
import CardBrandIcon from "./CardBrandIcon";
import styles from "../../styles/BillingPage.module.css";

const formatBrandLabel = (brand) => {
  const value = String(brand || "").trim();
  if (!value) return "Card";
  return value.charAt(0).toUpperCase() + value.slice(1);
};

const formatExpiry = (month, year) => {
  if (!month || !year) return null;
  const paddedMonth = String(month).padStart(2, "0");
  const fullYear = Number(year) < 100 ? 2000 + Number(year) : Number(year);
  return `${paddedMonth}/${fullYear}`;
};

const formatAddedDate = (dateValue) => {
  if (!dateValue) return null;
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const buildMetaText = (method) => {
  const expiry = formatExpiry(method?.exp_month, method?.exp_year);
  const added = formatAddedDate(method?.created_at || method?.added_at);

  const parts = [];
  if (expiry) parts.push(`Expires ${expiry}`);
  if (added) parts.push(`Added on ${added}`);
  return parts.join(" • ");
};

export default function PaymentMethodCard({
  method,
  isDefault = false,
  onSetDefault,
  settingDefault = false,
}) {
  const brandLabel = formatBrandLabel(method?.brand);
  const meta = buildMetaText(method);
  const last4 = method?.last4 || "----";

  return (
    <div className={styles.MethodCard}>
      <div className={styles.MethodMain}>
        <div className={styles.BrandBox}>
          <CardBrandIcon brand={method?.brand} />
        </div>
        <div className={styles.MethodDetails}>
          <div className={styles.MethodTitleRow}>
            <h4 className={styles.MethodTitle}>
              {brandLabel} ending in {last4}
            </h4>
            {isDefault && <span className={styles.DefaultBadge}>Default</span>}
          </div>
          {meta && <p className={styles.MethodMeta}>{meta}</p>}
        </div>
      </div>

      {!isDefault && (
        <div className={styles.MethodActions}>
          <Button
            type="button"
            className={`${btnStyles.Button} ${btnStyles.Shed} ${styles.PrimaryActionButton}`}
            onClick={onSetDefault}
            disabled={settingDefault}
          >
            {settingDefault ? "Updating..." : "Set as Default"}
          </Button>
        </div>
      )}
    </div>
  );
}
